export class RoleEnum {
  static ADMIN = 'admin';
  static MSSP = 'mssp';
  static ENTITY_LEADER = 'entity leader';
  static VENDOR_LEADER = 'vendor leader';
  static SUB_ENTITY_LEADER = 'sub entity leader';
  static PARTICIPANT = 'participant';
}
